
(function () {
  function isEffectivelyEmpty(el) {
    if (!el) return true;

    const text = (el.textContent || "")
      .replace(/\u00A0/g, " ")
      .trim();

    if (text.length > 0) return false;

    const realChildren = Array.from(el.children).filter(
      c => c.tagName !== "BR"
    );

    return realChildren.length === 0;
  }

  function hideEmptyBlocks() {
    document
      .querySelectorAll('.product-detail__information collapsible-block')
      .forEach(block => {
        const inner = block.querySelector('.collapsible-content_inner');

        if (isEffectivelyEmpty(inner)) {
          block.style.display = 'none';
        }
      });
  }

  // Corre imediatamente
  hideEmptyBlocks();

  // Corre após carregamento do DOM
  document.addEventListener('DOMContentLoaded', hideEmptyBlocks);

  // Observa conteúdo dinâmico (Shopify / AJAX / tema)
  const observer = new MutationObserver(hideEmptyBlocks);
  observer.observe(
    document.querySelector('.product-detail__information') || document.body,
    { childList: true, subtree: true }
  );
})();

 